(function () {
    require('./boot')();
})();



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0